import { useEffect, useState } from 'react';

/** Tailwind's `sm` breakpoint. */
const NARROW = '(max-width: 639px)';

/**
 * True while the viewport is phone-width.
 *
 * Extracted from TemplateSearchBox (2026-09-15) when the onboarding tool step
 * needed the same thing: a placeholder that fits a 560px field will clip
 * mid-word in a 343px one, and a placeholder that clips reads as a broken
 * promise. Both call sites answer that with a shorter string rather than a
 * smaller face, so the rule they share lives here.
 *
 * Guarded for jsdom, which has no `matchMedia`: tests get `false` and the full
 * string, rather than a crash on mount.
 */
export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(NARROW).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(NARROW);
    const onChange = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return narrow;
}

export default useNarrow;
